/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInterestSettingsRequest} from '@cash-web/protos/squareup/cash/app/get_interest_settings.pb'
import {GetInterestSettingsResponse} from '@cash-web/protos/squareup/cash/app/get_interest_settings.pb'


export const getInterestSettingsAppActionV2 = (request: GetInterestSettingsRequest, options?: CashRequestOptions) => post<GetInterestSettingsRequest, GetInterestSettingsResponse>("/2.0/cash/get-interest-settings-app-action-v2", request, {...options, rejectOnError: true })